import { OnboardingServices } from "shared/services";

OnboardingServices.registerTutorial(
	"dashboard-intro",
	{
		target: "body",
		content: "Bem-vindo ao Painel de Controle! Aqui você tem uma visão geral do sistema.",
		placement: "center",
	},
	{
		target: "#sidebar-menu",
		content: "Utilize o menu lateral (ou flutuante em dispositivos móveis) para navegar entre as diferentes seções.",
	},
	{
		target: "#topbar-user-menu",
		content: "Acesse seu perfil e configurações aqui.",
	},
);
